import { useState } from 'react'
import usePrevious from 'd2/hooks/usePrevious'
import type {
  CurrentSong,
  CurrentTime,
  Duration,
  Playing,
  Volume,
} from './types'

export const DEFAULT_PLAYING: Playing = false
export const DEFAULT_CURRENT_TIME: CurrentTime = 0
export const DEFAULT_DURATION: Duration = 0
export const DEFAULT_VOLUME: Volume = 0.5

export default function useAudioPlayer () {
  const [playing, setPlaying] = useState<boolean>(DEFAULT_PLAYING)
  const [currentTime, setCurrentTime] = useState<number>(DEFAULT_CURRENT_TIME)
  const [currentSong, setCurrentSong] = useState<CurrentSong | null | undefined>(null)
  const [duration, setDuration] = useState<Duration>(DEFAULT_DURATION)
  const [volume, setVolume] = useState<Volume>(DEFAULT_VOLUME)
  const previousSong = usePrevious(currentSong)
  const togglePlaying = () => setPlaying((current) => !current)

  return {
    currentSong,
    currentTime,
    duration,
    playing,
    previousSong,
    setCurrentSong,
    setCurrentTime,
    setDuration,
    setPlaying,
    setVolume,
    togglePlaying,
    volume,
  }
}
